<template>
  <!-- Yalnızca çok dilli (yurt dışı) dağıtımlarda görünür -->
  <div v-if="isI18nEnabled" class="relative" ref="rootEl">
    <button
      type="button"
      class="inline-flex items-center gap-1.5 px-2.5 py-2 min-h-[40px] rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition"
      :title="t('language.label')"
      :aria-label="t('language.label')"
      aria-haspopup="listbox"
      :aria-expanded="open"
      @click="open = !open"
    >
      <span class="text-base leading-none">{{ currentOption.flag }}</span>
      <span class="text-sm font-medium text-gray-700 dark:text-gray-200 hidden sm:inline">
        {{ currentOption.label }}
      </span>
      <i class="pi pi-chevron-down text-[10px] opacity-60"></i>
    </button>

    <div
      v-if="open"
      class="absolute right-0 mt-1 w-44 bg-white dark:bg-gray-800 rounded-xl shadow-lg border border-gray-200 dark:border-gray-700 py-1 z-50"
      role="listbox"
    >
      <button
        v-for="option in localeOptions"
        :key="option.value"
        type="button"
        role="option"
        :aria-selected="option.value === currentLocale"
        class="w-full flex items-center gap-2 px-3 py-2 text-sm text-left hover:bg-gray-50 dark:hover:bg-gray-700/60 transition"
        :class="option.value === currentLocale ? 'font-semibold text-primary-600 dark:text-primary-400' : 'text-gray-700 dark:text-gray-200'"
        @click="select(option.value)"
      >
        <span class="text-base leading-none">{{ option.flag }}</span>
        <span class="flex-1">{{ option.label }}</span>
        <i v-if="option.value === currentLocale" class="pi pi-check text-xs"></i>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useLocale } from '@/composables/useLocale'
import type { AppLocale } from '@/i18n'

const { t } = useI18n()
const { isI18nEnabled, localeOptions, currentLocale, currentOption, setLocale } = useLocale()

const open = ref(false)
const rootEl = ref<HTMLElement | null>(null)

function select(locale: AppLocale) {
  setLocale(locale)
  open.value = false
}

function onDocumentClick(e: MouseEvent) {
  if (!open.value) return
  if (rootEl.value && !rootEl.value.contains(e.target as Node)) {
    open.value = false
  }
}

onMounted(() => document.addEventListener('click', onDocumentClick))
onUnmounted(() => document.removeEventListener('click', onDocumentClick))
</script>
